<div data-test-id="init-loading-indicators"  class="text-center pt-5 pb-5 loading-indicator d-fixed">
  <app-spinner data-test-id="init-spinner"  class="app-spinner d-fixed"></app-spinner>
</div>
